import config from '@app/config'

import { extendLocaleWithLatinNumerics, getNumberFormat } from '@lib/utils'

import { ListingPriceFormattedParams } from './types'

export const getListingPriceFormatted = ({
  currencyId,
  amount,
  currentLocale,
  displaySymbol = true,
  minimumFractionDigits = 0,
  maximumFractionDigits = 0,
  signDisplay,
}: ListingPriceFormattedParams) => {
  const culture = extendLocaleWithLatinNumerics(currentLocale)
  let defaultResult = `${amount} ${currencyId}`
  let formatter

  try {
    if (!displaySymbol) {
      if (!amount) {
        return null
      }
      defaultResult = `${amount}`
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      formatter = getNumberFormat(culture, {
        minimumFractionDigits,
        maximumFractionDigits,
        signDisplay,
      })
    } else {
      if (!currencyId) {
        return null
      }
      const currencyDisplay = config.showCurrencySymbols.includes(currencyId)
        ? 'narrowSymbol'
        : 'code'
      const params: Partial<ListingPriceFormattedParams> = {
        style: 'currency',
        currencyDisplay,
        currency: currencyId,
        minimumFractionDigits,
        maximumFractionDigits,
        signDisplay,
      }
      try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        formatter = getNumberFormat(culture, params)
      } catch (e) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        formatter = getNumberFormat(culture, {
          ...params,
          currencyDisplay: 'code',
        })
      }
    }
    return formatter.format(amount)
  } catch (e) {
    console.error('Can not format price\n', e)
  }

  return defaultResult
}
